"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { useFavouriteWavesOfIdentity } from "@/hooks/useFavouriteWavesOfIdentity";
import { useWaves } from "@/hooks/useWaves";
import { useWaveCreatorPreviewModal } from "@/hooks/useWaveCreatorPreviewModal";
import { WaveCreatorPreviewModal } from "@/components/waves/drops/WaveCreatorPreviewModal";
import UserPageBrainSidebarCreated from "./UserPageBrainSidebarCreated";
import UserPageBrainSidebarMobileStrip from "./UserPageBrainSidebarMobileStrip";
import UserPageBrainSidebarMostActive from "./UserPageBrainSidebarMostActive";
import { getProfileWaveIdentity } from "./userPageBrainSidebar.helpers";
export default function UserPageBrainSidebar(t0) {
  const $ = _c(35);
  const {
    profile
  } = t0;
  let t1;
  if ($[0] !== profile) {
    t1 = getProfileWaveIdentity(profile);
    $[0] = profile;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const identity = t1;
  const hasIdentity = identity.length > 0;
  let t2;
  if ($[2] !== hasIdentity || $[3] !== identity) {
    t2 = {
      identity,
      waveName: null,
      enabled: hasIdentity,
      directMessage: false,
      limit: 20
    };
    $[2] = hasIdentity;
    $[3] = identity;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    waves: createdWaves,
    status: createdStatus
  } = useWaves(t2);
  let t3;
  if ($[5] !== hasIdentity || $[6] !== identity) {
    t3 = {
      identityKey: identity,
      limit: 3,
      enabled: hasIdentity
    };
    $[5] = hasIdentity;
    $[6] = identity;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    waves: mostActiveWaves,
    status: mostActiveStatus
  } = useFavouriteWavesOfIdentity(t3);
  const {
    isModalOpen,
    handleBadgeClick,
    handleModalClose
  } = useWaveCreatorPreviewModal();
  let t4;
  if ($[8] !== profile.handle || $[9] !== profile.primary_wallet) {
    t4 = {
      handle: profile.handle,
      primary_address: profile.primary_wallet
    };
    $[8] = profile.handle;
    $[9] = profile.primary_wallet;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const modalUser = t4;
  const shouldShowCreated = createdStatus === "pending" || createdWaves.length > 0;
  const shouldShowMostActive = mostActiveStatus === "pending" || mostActiveWaves.length > 0;
  if (!shouldShowCreated && !shouldShowMostActive) {
    return null;
  }
  let t5;
  if ($[11] !== createdStatus || $[12] !== createdWaves || $[13] !== handleBadgeClick || $[14] !== mostActiveStatus || $[15] !== mostActiveWaves) {
    t5 = <UserPageBrainSidebarMobileStrip createdWaves={createdWaves} createdStatus={createdStatus} mostActiveWaves={mostActiveWaves} mostActiveStatus={mostActiveStatus} onOpenCreatedWaves={handleBadgeClick} />;
    $[11] = createdStatus;
    $[12] = createdWaves;
    $[13] = handleBadgeClick;
    $[14] = mostActiveStatus;
    $[15] = mostActiveWaves;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== createdStatus || $[18] !== createdWaves || $[19] !== identity) {
    t6 = <UserPageBrainSidebarCreated identity={identity} waves={createdWaves} status={createdStatus} />;
    $[17] = createdStatus;
    $[18] = createdWaves;
    $[19] = identity;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== mostActiveStatus || $[22] !== mostActiveWaves) {
    t7 = <UserPageBrainSidebarMostActive waves={mostActiveWaves} status={mostActiveStatus} />;
    $[21] = mostActiveStatus;
    $[22] = mostActiveWaves;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t6 || $[25] !== t7) {
    t8 = <div className="tw-hidden tw-space-y-6 lg:tw-block" data-testid="brain-sidebar-desktop">{t6}{t7}</div>;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== handleModalClose || $[28] !== isModalOpen || $[29] !== modalUser) {
    t9 = <WaveCreatorPreviewModal isOpen={isModalOpen} onClose={handleModalClose} user={modalUser} />;
    $[27] = handleModalClose;
    $[28] = isModalOpen;
    $[29] = modalUser;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== t5 || $[32] !== t8 || $[33] !== t9) {
    t10 = <aside className="tw-order-1 tw-min-w-0 tw-self-start lg:tw-sticky lg:tw-top-8 lg:tw-order-2" data-testid="brain-sidebar">{t5}{t8}{t9}</aside>;
    $[31] = t5;
    $[32] = t8;
    $[33] = t9;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  return t10;
}